import { View } from "react-native";

export interface TabPageTemplateProps {
  children?: React.ReactNode;
  header?: React.ReactNode;
}

export function TabPageTemplate({
  children,
  header,
}: TabPageTemplateProps) {
  return (
    <View>
      {header}
      {children}
    </View>
  );
}
